import { Component, Input } from '@angular/core';
import { InternalMsgService } from '../services/internal.msg.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-str-spinner',
    templateUrl: './str-spinner.component.html',
    styleUrls: ['./str-spinner.component.css']
})
export class StrSpinnerComponent {
    @Input() message: string = '';

    msgSubscr: Subscription = new Subscription();
    isVisible: boolean = false;

    constructor(private msgService: InternalMsgService) { }

    ngOnInit(): void {
        this.msgSubscr = this.msgService.toggleSpinnerSet$.subscribe(isLoading => {
            this.isVisible = isLoading;
        });    
    }

    getMessage(): string {
        return this.message.trim() == ''
            ? 'Please wait, data is being handled'
            : this.message;
    }
}
